document.addEventListener("DOMContentLoaded", function () {
    // menu open on hover
    const header = document.querySelector(".header__inline-menu");
    if(header){
        const detailsItems = header.querySelectorAll("details");
        detailsItems.forEach(item => {
            item.addEventListener("mouseover", () => {
                item.setAttribute("open", true);
            });
            item.addEventListener("mouseleave", () => {
                item.removeAttribute("open");
            });
        });
    }

    document.querySelectorAll(".footer-bottom .col-links b").forEach((heading) => {
        heading.addEventListener("click", () => {
            const parent = heading.parentElement;
            const icon = heading.querySelector("span");
            // Close others
            document.querySelectorAll(".col-links").forEach((item) => {
                if (item !== parent) {
                    item.classList.remove("active");
                    item.querySelector("span").textContent = "+";
                }
            });
            // Toggle current
            parent.classList.toggle("active");
            icon.textContent = parent.classList.contains("active") ? "−" : "+";
        });
    });

    // s3 video script 
    const popup = document.getElementById("videoPopup");
    const video = document.getElementById("popupVideo");
    const closeBtn = document.querySelector(".video-close");
    // OPEN POPUP (event delegation - works after filters/sort)
    let maxLoops = 2;
    var vloops = 0;
    document.addEventListener("click", function (e) {
        const el = e.target.closest(".s3v-play");
        if (!el) return;

        if (!popup || !video) return;

        const videoName = el.getAttribute("data-url");
        const videoUrl = "https://d20f1q7hs4tnec.cloudfront.net/videos/" + videoName;
        const source = video.querySelector("source");
        if (source) {
            source.src = videoUrl;
            video.load();
        }
        popup.style.display = "block";
        //set limit video play         
        vloops = 0;
        video.dataset.looped = 'false';
        video.loop = true;        
        video.addEventListener('timeupdate', function () {
            if (video.currentTime < 0.5 && !video.paused) {                
                if (video.dataset.looped !== 'true') {
                    vloops++;
                    video.dataset.looped = 'true';
                    if (vloops >= maxLoops) {
                        video.loop = false;
                    }
                }
            } else {                
                video.dataset.looped = 'false';
            }
        });
    });
    // CLOSE BUTTON
    if (closeBtn && popup && video) {
        closeBtn.addEventListener("click", function () {
            popup.style.display = "none";
            video.pause();
            video.currentTime = 0;
        });
    }
    // CLICK OUTSIDE TO CLOSE
    if (popup && video) {
        popup.addEventListener("click", function (e) {
            if (e.target === popup) {
                popup.style.display = "none";
                video.pause();
                video.currentTime = 0;
            }
        });
    }
    // hide s3 video if not available
    document.querySelectorAll('.s3v-play').forEach(function(el) {
        const url = el.getAttribute('data-url');
        const video = document.createElement('video');
        video.src = "https://d20f1q7hs4tnec.cloudfront.net/videos/" +url;
        video.addEventListener('error', function () {
            el.style.display = 'none';
        });
    });
    
    // product certificate popup    
    const certificatePopup = document.getElementById("certificatePopup");
    const certificatePopupOpen = document.getElementById("certificatePopupOpen");
    const certificatecloseBtn = document.querySelector(".certificate-close");
    if (certificatePopupOpen && certificatePopup && certificatecloseBtn) {
        // open popup
        certificatePopupOpen.addEventListener("click", function () {
            certificatePopup.style.display = "block";
        });
        // close popup
        certificatecloseBtn.addEventListener("click", function () {
            certificatePopup.style.display = "none";
        });
        // click outside to close
        certificatePopup.addEventListener("click", function (e) {
            if (e.target === certificatePopup) {
                certificatePopup.style.display = "none";
            }
        });
    }

    // ring size guide tabbing
    const tabButtons = document.querySelectorAll(".sizetab-btn");
    const tabContents = document.querySelectorAll(".sizetab-content");
    if (tabButtons && tabContents) {
        tabContents.forEach(content => content.style.display = "none");
        // Show first tab by default
        if (tabContents.length > 0) {
            tabContents[0].style.display = "block";
        }
        if (tabButtons.length > 0) {
            tabButtons[0].classList.add("active");
        }
        // Click event
        tabButtons.forEach(button => {
            button.addEventListener("click", function () {
                const tabId = this.getAttribute("data-tab");
                // Remove active from all buttons
                tabButtons.forEach(btn => btn.classList.remove("active"));            
                this.classList.add("active");
                // Hide all contents
                tabContents.forEach(content => content.style.display = "none");            
                const target = document.getElementById(tabId);
                if (target) {
                    target.style.display = "block";
                }
            });
        });
    }

    (function () {
        let thumbsLoaded = false;
        function loadMenuThumbs() {
        if (thumbsLoaded) return;
        thumbsLoaded = true;
        const gemstoneThumbs = {
            'blue-sapphire-neelam': 'thumb_blue-sapphire-neelam.webp',
            'cats-eye-lehsuniya': 'thumb_cats-eye-lehsuniya.webp',
            'emerald-panna': 'thumb_emerald-panna.webp',
            'hessonite-gomed': 'thumb_hessonite-gomed.webp',
            'opal': 'thumb_opal.webp',
            'pearl-moti':'thumb_pearl-moti.webp',
            'red-coral-moonga':'thumb_red-coral-moonga.webp',
            'ruby-manik':'thumb_ruby-manik.webp',
            'yellow-sapphire-pukhraj':'thumb_yellow-sapphire-pukhraj.webp',
            'yellow-sapphire':'thumb_yellow-sapphire-pukhraj.webp',
            'blue-sapphire':'thumb_blue-sapphire-neelam.webp',
            'pink-sapphire':'thumb_pink-sapphire.webp',
            'bi-color-sapphire':'thumb_bi-color-sapphire.webp',
            'white-sapphire':'thumb_white-sapphire.webp',
            'purple-sapphire':'thumb_purple-sapphire.webp',
            'green-sapphire':'thumb_green-sapphire.webp',           
            'alexandrite':'thumb_alexandrite.png',
            'chrysoberyl-cats-eye':'thumb_cats-eye-lehsuniya.webp',
            'colombian-emerald':'thumb_emerald-panna.webp',
            'mozambique-ruby':'thumb_ruby-manik.webp',
            'spinel':'thumb_spinel.jpg',
            'tahitian-pearl':'thumb_tahitian-pearl.jpg',
            'amethyst':'thumb_amethyst.png',
            'bi-color':'thumb_bi-color-sapphire.webp',
            'agate':'thumb_agate.png',
            'ametrine':'thumb_ametrine.png',
            'aquamarine':'thumb_aquamarine.png',
            'black-onyx':'thumb_black-onyx.png',
            'blue-topaz':'thumb_blue-topaz.png',
            'blue-moonstone':'thumb_blue-moonstone.jpg',
            'blue-zircon':'thumb_blue-zircon.jpg',
            'citrine-sunela':'thumb_citrinesunela.png',
            'garnet':'thumb_garnet_v2.jpg',
            'green-aventurine':'thumb_green-aventurine.png',
            'green-onyx':'thumb_green-onyx.png',
            'green-tourmaline':'thumb_green-tourmaline.png',
            'iolite':'thumb_iolite.png',
            'irani-turquoise':'thumb_irani-turquoise.png',
            'turquoise':'thumb_irani-turquoise.png',
            'kyanite-stone':'thumb_kyanite-stone.png',
            'lapis-lazuli':'thumb_lapis-lazuli.png',
            'moonstone':'thumb_moonstone.png',
            'malachite':'thumb_malachite.png',
            'peridot-stone':'thumb_peridot-stone.png',
            'pyrite-stone':'thumb_pyrite-stone.png',
            'rock-crystal':'thumb_rock-crystal.png',
            'star-ruby':'thumb_star-ruby.png',
            'sulemani-hakik':'thumb_sulemani-hakik.png',
            'sunstone':'thumb_sunstone.png',
            'tigers-eye-stone':'thumb_tigers-eye-stone.png',
            'white-coral':'thumb_white-coral.png',
            'white-zircon':'thumb_white-zircon.png',
            'white-topaz':'thumb_white-topaz.png',
            'yellow-topaz':'thumb_yellow-topaz.png',
            'smoky-quartz':'thumb_smoky-quartz.jpg',
            'yellow-zircon':'thumb_yellow-zircon.jpg',
            'yemeni-aqeeq':'thumb_yemeni-aqeeq_v2.png',
            'diamond-heera':'thumb_diamond.jpg',
            'basra-pearl':'thumb_basra-pearl.png',
            'burma-ruby':'thumb_burma-ruby.jpg',
            'australian-opal':'thumb_opal.webp',
            'zambian-emerald':'thumb_zambian-emerald.jpg',
            'ceylon-blue-sapphire':'thumb_blue-sapphire-neelam.webp',
            'ceylon-yellow-sapphire':'thumb_yellow-sapphire-pukhraj.webp',
        };          
        const imageBasePath = '/cdn/shop/files/';
        Object.entries(gemstoneThumbs).forEach(([slug, imageName]) => {
            document.querySelectorAll('.thumb_' + slug).forEach(span => {
                if (span.querySelector('.menu-thumb')) return;

                const img = document.createElement('img');
                img.src = imageBasePath + imageName;
                img.alt = `Menu ${span.textContent.trim()}`;
                img.className = 'menu-thumb';
                img.loading = 'lazy';
                img.width = 20;
                img.height = 20;
                span.prepend(img);
            });
        });
        }
        ['scroll', 'mousemove', 'touchstart', 'click'].forEach(event => {
            window.addEventListener(event, loadMenuThumbs, {
                passive: true,
                once: true
            });
        });
    })();
});